import { useLogger } from './doyo.useLogger.js';
import { sleep } from './doyo.utils.js';

(async () => {
  const { Log } = useLogger('Main');

  /**
   * @typedef {() => Promise<void>} PromiseVoidFunction
   * @typedef {() => Promise<boolean>} PromiseBooleanFunction
   * @typedef {Object} DoWhileCheckOption
   * @property {number|undefined} waitTime 检测等待时间
   * @property {number|undefined} overCount 计数超时次数 - 默认 Infinity 无限制
   * @property {PromiseVoidFunction|VoidFunction|undefined} success 完成判定
   * @property {PromiseVoidFunction|VoidFunction|undefined} fail 超次数
   * @property {PromiseVoidFunction|VoidFunction|undefined|(count:number)=>void} next 将继续下次循环
   *
   * @param {PromiseBooleanFunction} func 判断函数
   * @param {DoWhileCheckOption} options 选项
   */
  const doWhileCheck = async (func, options) => {
    let count = 0;
    const { waitTime = 100, overCount = Infinity, success, fail, next = () => void 0 } = options;

    while (true) {
      if (func()) {
        await success?.();
        break;
      } else {
        count++;
        if (overCount !== Infinity && overCount > 0 && count > overCount) {
          // Log('fail');
          fail?.();
          break;
        } else {
          // Log('next');
          next?.(count);
          await sleep(waitTime);
        }
      }
    }
  };

  if (
    !(
      '/pages/search-results-page' === window.location.pathname ||
      /^\/collections\//.test(window.location.pathname)
    )
  ) {
    Log('not match search page, exit');
    return;
  } else {
    Log('matched, go on');
  }

  await doWhileCheck(() => 'jQuery' in window, {
    success: () => {
      Log('已加载到jQuery');
    },
    next: () => {
      Log('尚未加载到jQuery');
    },
  });

  await sleep(1_000);

  let len = 0;

  await doWhileCheck(() => $('#snize_results .snize-item .total-reviews').length > 0, {
    success: () => {
      // do nth
      // Log('got product dom');
    },
    next: () => {
      // Log('wait...', count)
    },
  });

  function reviews_words_mod() {
    $('#snize_results .snize-item .total-reviews').each((_index, el) => {
      const new_review_words = $(el)
        .text()
        .replace(/review\(s\)/iu, 'reviews');
      $(el).text(new_review_words);
    });

    len = $('#snize_results .snize-item .total-reviews').length;
  }

  function check_and_mod() {
    doWhileCheck(() => $('#snize_results .snize-item .total-reviews').length > len, {
      success: () => {
        // Log('数据量有增长，修改')

        reviews_words_mod();
      },
      next: () => {
        // Log('无数据量变化，跳过');
      },
    });
  }

  function check_and_mod_v2() {
    const $list = document.querySelector('ul.snize-search-results-content');
    let observer = new MutationObserver(mutationsList => {
      mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
          Log('列表数据量发生变化，当前数量:', $($list).children().length);
          reviews_words_mod();
        }
      });
    });

    // 配置观察选项
    observer.observe($list, { attributes: false, childList: true, subtree: false });

    Log('observer start!');
  }

  check_and_mod_v2();
  check_and_mod();

  /**
   * 触发resize
   */
  const resize = () => {
    const resizeEvent = document.createEvent('Event');
    resizeEvent.initEvent('resize', true, true);
    window.dispatchEvent(resizeEvent);
  };

  const fixSearchResultStyle = async () => {
    if ('/pages/search-results-page' === window.location.pathname) {
      Log('search page, trigger resize');

      $('#snize_results').parent().css('width', '100%');
      resize();

      for (let index = 1; index < 10; index++) {
        await sleep(500);
        Log(`trigger resize ${index}`);
        resize();
      }
    } else {
      Log('not search page, skip');
    }
  };

  fixSearchResultStyle();
})();
